import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { onSnapshot, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';

function Featured() {
  const [amount, setAmount] = useState(null);
  const [diff, setDiff] = useState(null);
  const [useSpace, setUseSpace] = useState(null);
  const { userId } = useParams();

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'users', userId), (doc) => {
      setAmount(doc.data().space.toFixed(2));
      const newFile = (1000 - doc.data().space).toFixed(2);
      const thediff = doc.data().space.toFixed(0) / 10;
      setUseSpace(newFile);
      setDiff(thediff);
    });

    return () => {
      unsub();
    };
  }, [userId]);

  return (
    <FeaturedStyled>
      <div className="top">
        <h1 className="title">Upload Details</h1>
      </div>
      <div className="bottom">
        <div className="featured-chart">
          <CircularProgressbar value={diff} text={`${diff}%`} strokeWidth={5} />
        </div>
        <p className="title">Total space available</p>
        <p className="desc">See how much space you still have in your environment</p>
        <div className="summary">
          <div className="item">
            <div className="item-title">Used</div>
            <div className="item-result">
              <div className="result-amount">{useSpace} MB</div>
            </div>
          </div>
          <div className="item">
            <div className="item-title">Available</div>
            <div className="item-result">
              {amount < 1000 ? (
                <div className="result-amount">{amount} MB</div>
              ) : (
                <div className="result-amount">{amount / 1000} GB</div>
              )}
            </div>
          </div>
          <div className="item">
            <div className="item-title">Total</div>
            <div className="item-result">
              <div className="result-amount">1GB</div>
            </div>
          </div>
        </div>
      </div>
    </FeaturedStyled>
  );
}

const FeaturedStyled = styled.div`
  flex: 2;
  -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
  padding: 10px;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--accent-blue);
    -webkit-box-shadow: none;
    box-shadow: none;

    .title {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .bottom {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    box-shadow: none;

    .featured-chart {
      width: 220px;
      height: 220px;

      .CircularProgressbar-path {
        stroke: var(--accent-blue);
      }
    }

    .title {
      font-weight: 500;
      color: gray;
    }
    .amount {
      font-size: 30px;
    }
    .desc {
      font-weight: 300;
      font-size: 12px;
      color: gray;
      text-align: center;
    }
    .summary {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        text-align: center;

        .item-title {
          font-size: 14px;
          color: var(--accent-blue);
        }

        .item-result {
          margin: 10px;
          font-size: 14px;
          text-align: center;
          align-items: center;
          display: block;
          color: gray;
        }
      }
    }
  }
`;

export default Featured;
